import { AppLayoutComponent } from './app-layout/app-layout.component';
import { HeaderComponent } from './header/header.component';
import { BrandingComponent } from './header/widgets/branding.component';
import { EdbHeaderItemsComponent } from './header/widgets/edbHeaderItems/edbHeaderItems.component';
import { TranslateComponent } from './header/widgets/translate.component';
import { UserComponent } from './header/widgets/user/user.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { AccordionDirective } from './sidemenu/accordion.directive';
import { AccordionItemDirective } from './sidemenu/accordionItem.directive';
import { AccordionAnchorDirective } from './sidemenu/accordionanchor.directive';
import { IAccordionDirectiveInjectionToken } from './sidemenu/iAccordionDirective';
import { SidemenuComponent } from './sidemenu/sidemenu.component';
import { TopmenuComponent } from './topmenu/topmenu.component';
import { NgModule } from '@angular/core';
import { SharedModule } from '@shared/shared.module';

@NgModule({
  declarations: [
    AppLayoutComponent,
    SidebarComponent,
    SidemenuComponent,
    AccordionDirective,
    AccordionItemDirective,
    AccordionAnchorDirective,
    TopmenuComponent,
    HeaderComponent,
    BrandingComponent,
    TranslateComponent,
    UserComponent,
    EdbHeaderItemsComponent,
  ],
  imports: [SharedModule],
  providers: [{ provide: IAccordionDirectiveInjectionToken, useClass: AccordionDirective }],
})
export class ThemeModule {}
